const timeRemaining = (endUnixTimestamp) => {
  // const endDate = unixTimestampToDate(endUnixTimestamp);
  const endDate = new Date(endUnixTimestamp * 1000);
  const now = new Date();
  const diff = timeDifference(endDate, now);
  if (diff === '') {
    return '<1 min';
  }
  return diff;
};

const unixTimestampToDateString = function (unix_timestamp) {
  return new Date(unix_timestamp * 1000).toLocaleString();
};

const timeDifference = (date1, date2) => {
  let difference = date1.getTime() - date2.getTime();

  const daysDifference = Math.floor(difference / 1000 / 60 / 60 / 24);
  difference -= daysDifference * 1000 * 60 * 60 * 24;

  const hoursDifference = Math.floor(difference / 1000 / 60 / 60);
  difference -= hoursDifference * 1000 * 60 * 60;

  const minutesDifference = Math.floor(difference / 1000 / 60);
  difference -= minutesDifference * 1000 * 60;

  return (daysDifference > 0 ? daysDifference + 'd. ' : '') + (hoursDifference > 0 ? hoursDifference + 'h ' : '') + (minutesDifference > 0 ? minutesDifference + ' min' : '');
};

// const unixTimestampToDate = (unix_timestamp) => {
// // Create a new JavaScript Date object based on the timestamp
// // multiplied by 1000 so that the argument is in milliseconds, not seconds.
//   const date = new Date(unix_timestamp * 1000);
//   const days = date.getDate();
//   const hours = date.getHours();
//   const minutes = "0" + date.getMinutes();
//   const seconds = "0" + date.getSeconds();
//
//   // Will display time in 5d. 10:30:23 format
//   const formattedTime = days + 'd. ' + hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
//
//   return formattedTime;
// };

const unixTimestampToDays = (unix_timestamp) => {
  const days = Math.floor(unix_timestamp / 86400);
  unix_timestamp -= days * 86400;

  const hours = Math.floor(unix_timestamp / 3600);
  unix_timestamp -= hours * 3600;

  const minutes = Math.floor(unix_timestamp / 60);
  unix_timestamp -= minutes * 60;

  return (days > 0 ? days + 'd. ' : '') + (hours > 0 ? hours + 'h ' : '') + (minutes > 0 ? minutes + ' min' : '');
};

const hasPassed = (timestamp) => {
  const now = Math.floor(Date.now() / 1000);
  return timestamp <= now;
};

const daysToSeconds = (days) => {
  const ONE_DAY_SECONDS = 86400;
  return days * ONE_DAY_SECONDS;
};

exports.timeRemaining = timeRemaining;
exports.unixTimestampToDateString = unixTimestampToDateString;
exports.timeDifference = timeDifference;
exports.unixTimestampToDays = unixTimestampToDays;
exports.hasPassed = hasPassed;
exports.daysToSeconds = daysToSeconds;
